import styled from "@emotion/native";
import Text from "../Text";
import { AppTheme } from "../../utils/theme";

export const Container = styled.View({
    flex: 1,
    height: 140,
    width: 235,
    marginRight: 10,
    justifyContent: "center",
    alignItems: "center",
});

export const Tile = styled.Image({
    position: "absolute",
    width: "100%",
    height: "100%",
    resizeMode: "cover",
    zIndex: 0,
});

export const Title = styled(Text)(
    {
        position: "relative",
        zIndex: 1,
        textAlign: "center",
        paddingVertical: 22,
        paddingHorizontal: 14,
        fontWeight: "bold",
    },
    ({ theme }: { theme: AppTheme }) => {
        return {
            fontFamily: theme.fonts.bodyBold,
        };
    },
);
